import React from "react";
import { useTranslation } from "react-i18next";

const InvalidLinkMessage = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center relative z-10">
      <h2 className="text-2xl text-slate-700 mb-2 font-heading">
        {t("invalid_message.title")}
      </h2>
      <p className="text-md text-slate-600 mb-4">
        {t("invalid_message.message")}
      </p>
      {/* <button
        className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white font-medium rounded-md transition-colors 
        shadow-md hover:shadow-lg transform hover:-translate-y-0.5 active:translate-y-0 active:shadow-md"
        onClick={() => window.location.href = "mailto:support@example.com"}
      >
        Skontaktuj się z obsługą
      </button> */}
    </div>
  );
};

export default InvalidLinkMessage;